<template>
  <v-snackbar-queue v-model="toastStore.messages" timeout="3000" closable />
</template>

<script setup>
import { useToastStore } from '@/stores'

const toastStore = useToastStore()
</script>
